module.exports = __webpack_public_path__ + "static/media/09_2.7565eafd.png";